import React from "react";

export default function useEventListener(eventNames, handler, element = window) {
    const savedHandler = React.useRef();
  
    React.useEffect(() => {
      savedHandler.current = handler;
    }, [handler]);
  
    React.useEffect(() => {
        if (!element || !element.addEventListener) return; // Make sure this is supported
  
        const eventListener = event => savedHandler.current(event);
  
        // Add event listener
        for (let eventName of eventNames.split(' ')) {
          element.addEventListener(eventName, eventListener);
        }
  
        // Remove event listener on cleanup
        return () => {
          for (let eventName of eventNames.split(' ')) {
            element.removeEventListener(eventName, eventListener);
          }
        };
      },
      [eventNames, element] // Re-run if eventName or element changes
    );
};